import FJTextStyle from './FJTextStyle';
import FJOutline from './style/FJOutline';

class FJTextStyleHollow extends FJTextStyle {
    initStyles(props = {}) {
        let textOutline = new FJOutline({
            ...props,
            position: 'relative',
            textColor: 'transparent',
            color: '#FC4506',
            width: 20,
            widthRef: 1200,
        });
        this._styles = [textOutline];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: *, width: *}}
     */
    getAdjustInfo() {
        let outline = this._styles[0];
        return {
            width: outline.width,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        if (info.width !== '') this._styles[0].width = info.width;
    }

    /**
     * @description 设置color
     * @param color
     */
    setColor(color) {
        this._styles.forEach(style => {
            style.color = color;
        });
    }

    /**
     * 将style应用到
     * @param view
     * @param textData
     * @param options
     */
    addToView(view, textData, options) {
        if (!view) return;
        if (this._enableStyle) {
            this._baseStyle.addToView(view, textData, options);
            return;
        }

        this._styles.forEach(style => {
            style.addToView(view, textData, { ...options, isAddToSupportLayer: false });
        });
    }
}

export default FJTextStyleHollow;
